<template>
  <div class="login">
    <Loading v-if="loading" />
    <UserCard v-else />
    <CommonCard />
    <MiniPayModal />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Loading from './components/loading.vue';
import UserCard from './components/user-card.vue';
import CommonCard from './components/common-card.vue';
import MiniPayModal from './components/mini-pay-modal.vue';
import { useLoginStore } from '@/store';

const loginStore = useLoginStore();
const loading = computed(() => loginStore.isFisrtLoading);

</script>

<style lang="scss" scoped>
.login {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #111111;
  border-radius: 16px;
}
</style>
